export const CHART_COLORS = {
  US: '#0078D4',          // Azure blue for US
  International: '#50E6FF' // Light blue for International
};

export const CHART_LABELS = {
  US: 'US Customers',
  International: 'International Customers'
};